const globalColorSwatches = document.getElementById('colorSwatchesData') ? JSON.parse(document.getElementById('colorSwatchesData').innerText) : null;
const storedProductSkusInSession = JSON.parse(sessionStorage.getItem("productSkus"));
const swatches = document.querySelectorAll('[data-swatches-template]');



/****
 * 
 * Helpers
 * 
 */

const groupBy = (data, ...keys) => {
    // Takes an array of objects and the property by which they should be grouped.
    // Produces an object of arrays keyed by the specified property values.
    // 
    // Provide multiple keys if your data is nested:   groupBy(dogs, 'values', 'emoji')
    // 
    // Ex: [{id: 1, group: 'A'}, {id: 2, group: 'B'}, {id: 3, group: 'A'}],   'group'
    //     =>
    //     {A: [{id: 1, group: 'A'}, {id: 3, group: 'A'}], B: [{id: 2, group: 'B'}]}

    // Ex: {values: {color: 'red'}}, ['values', 'color'] => 'red'
    const getGroupFromItem = (item, keys) => {
        return (keys.length > 1)
            ? getGroupFromItem(item[keys[0]], keys.slice(1))
            : item[keys[0]]
    }

    return data.reduce((results, item) => {
        // Get the first instance of the key by which we're grouping
        var group = getGroupFromItem(item, keys);

        // Ensure that there's an array to hold our results for this group
        results[group] = results[group] || [];

        // Add this item to the appropriate group within results
        results[group].push(item);

        // Return the updated results object to be passed into next reduce call
        return results;
    },
        // Initial value of the results object
        {}
    );
};

/****
 * 
 * Helpers End
 * 
 */

class ColorSwatches {

    constructor({ globalColorSwatches, globalLinkedProducts, elem }) {
        this.dom = {
            swatches: elem
        }
        this.options = {}

        this.options = this.getSkuData();
        this.options.id = elem.dataset.swatchesId ? elem.dataset.swatchesId : null
        this.options.type = elem.dataset.swatchesTemplateType ? elem.dataset.swatchesTemplateType : null
        this.options.keep = false;

       

        switch (this.options.type) {
            case 'collection':
                this.options.limit = 11;
                break;
        
            default:
                this.options.limit = 0;
                break;
        }

        this.colors = globalColorSwatches;
        this.linkedProducts = this.getLinkedProducts({ jsonProductData: globalLinkedProducts });

        this.dom.swatches.removeAttribute('data-swatches-template');
        if (this.linkedProducts === undefined || this.linkedProducts.length <= 1) return this.dom.swatches.remove();

        this.initColorSwatches()
    }

    getSkuData() {
        const productSku = this.dom.swatches.dataset.productSku;
        const productSkuArr = productSku.split('\\');
        /** first item in the array is the sku */
        /** secound item in the array is the colour name */


        /**
         * Gives => 
         * this.options.sku
         * this.optins.color
         */

        return { "sku": productSkuArr[0], "color": productSkuArr[1] }
    }

    getLinkedProducts({ jsonProductData }) {
        if (jsonProductData) {
            return jsonProductData[this.options.sku];
        }
        else{
            console.warn('no jsonProductData');
         return null;
        }
    }


    initColorSwatches() {
        /** Creating the colour swatches */
        this.createFragments();
    }

    createFragments() {

        const fragment = new DocumentFragment();
        const itemElement = this.dom.swatches.querySelector('.js-color-Swatches__item');
        const itemListElement = this.dom.swatches.querySelector('.js-color-Swatches__list');
        const currentColorObj = {};
        currentColorObj.element = this.dom.swatches.querySelector('[data-color-swatches-current-color]')
        //currentColorObj.text = currentColorObj.element.dataset.colorSwatchesCurrentColor;

        if (this.linkedProducts.length > 1)
        {

            /**
             * Look at this
             */
            //const linkedProducts = this.options.limit != null ? this.linkedProducts.slice(-(Number(this.options.limit))) : this.linkedProducts;

            this.linkedProducts.slice(-(Number(this.options.limit))).forEach((item, i) => {

                /**Cloning node and creating template for swatches to manipulate */

                const template = itemElement.cloneNode(true)
                switch (this.options.type)
                {
                    case 'collection':
                        this.swatchesOnCollectionPage({ item: item, itemListElement: itemListElement, template: template, currentColorObj: currentColorObj })
                        break;

                    default:
                        this.SwatchesOnProductPage({ item: item, template: template, currentColorObj: currentColorObj });
                        break;
                }

                fragment.appendChild(template)
            })

            /**
             * Adding a plus sign, if the amount of variants are more than the limit
             */
             if (window.location.href.indexOf('/collections/') != -1 && window.location.href.indexOf('/products/') == -1 && this.linkedProducts.length > 8) {
                const plusIconContainer = itemElement.cloneNode(true);
                plusIconContainer.innerHTML = ''; 
                const plusIcon = document.createElement('a');
                plusIcon.setAttribute('href', this.linkedProducts[0].url); 
                // plusIcon.setAttribute('href', item.url);
                plusIconContainer.classList.add('plus-icon__container');
                plusIcon.classList.add('plus-icon');
                
                plusIconContainer.appendChild(plusIcon);

                fragment.appendChild(plusIconContainer); 

            } else if (this.options.limit !== 0 && this.linkedProducts.length > this.options.limit) {
                
                // const plusIconContainer = itemElement.cloneNode(true);
                // plusIconContainer.innerHTML = '';
                // const plusIcon = document.createElement('div');
                // plusIconContainer.classList.add('plus-icon__container');
                // plusIcon.classList.add('plus-icon');
                // const svg = '<svg version="1.1" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve"><path d="M61,30.3H33.8V3c0-1-0.8-1.8-1.8-1.8S30.3,2,30.3,3v27.3H3c-1,0-1.8,0.8-1.8,1.8S2,33.8,3,33.8h27.3V61c0,1,0.8,1.8,1.8,1.8  s1.8-0.8,1.8-1.8V33.8H61c1,0,1.8-0.8,1.8-1.8S62,30.3,61,30.3z"/></svg>';
                // plusIcon.innerHTML = svg;
                // plusIconContainer.appendChild(plusIcon);
                // fragment.appendChild(plusIconContainer);

                
                const plusIconContainer = itemElement.cloneNode(true);
                plusIconContainer.innerHTML = '';
                const plusIcon = document.createElement('div');
                // plusIcon.setAttribute('href', item.url);
                plusIconContainer.classList.add('plus-icon__container');
                plusIcon.classList.add('plus-icon');
              
                plusIconContainer.appendChild(plusIcon);

                fragment.appendChild(plusIconContainer);

            }
            /**Removing placeholders and adding corrct swatches */
            itemListElement.innerHTML = '';
            itemListElement.appendChild(fragment)

        } else
        {
            itemListElement.innerHTML = '';
        }


    }


    swatchesOnCollectionPage({ item, itemListElement, template, currentColorObj }) {
        const productCollectionCardObj = { dom: {} };
        productCollectionCardObj.dom.main = this.dom.swatches.closest(`[data-product-variant-id="${ this.options.id }"]`);
        productCollectionCardObj.dom.title = productCollectionCardObj.dom.main.querySelector('.product-collection__title a');
        productCollectionCardObj.dom.swatchImage = productCollectionCardObj.dom.main.querySelector('.product-collection__swatch-image');


        if (!productCollectionCardObj.dom.main)  return this.dom.swatches.remove();

        this.changeColorTitle({ item, itemListElement, template, currentColorObj })


        if (item.colorName)
        {
            template.querySelector('.js-color-swatch__url').setAttribute('title', item.colorName);
            template.querySelector('.js-color-Swatches__swatch').setAttribute('alt', item.colorName);
        }


        let globalSwatchValue = null;

        if (globalColorSwatches[item.color] != undefined)
        {
            globalSwatchValue = globalColorSwatches[item.color];
        }

        if (globalSwatchValue && globalSwatchValue.charAt(0) === '#')
        {
            /**Hex code */
            let images = template.querySelectorAll('.js-color-Swatches__swatch img');
 
            for (var i = 0; i < images.length; i++) {
                images[i].remove();
            }


            let swatches = template.querySelectorAll('.js-color-Swatches__swatch');
 

            for (var i = 0; i < swatches.length; i++) {
                swatches[i].style.backgroundColor = globalSwatchValue;
            } 

 
        }
        else
        {
            const itemImage = globalSwatchValue ? globalSwatchValue : item.image;

            if (itemImage)
            {
                /***
                 * Include this in theme {{ 'option_selection.js' | shopify_asset_url | script_tag }}
                 */
                const imageUrl = Shopify.Image.getSizedImageUrl(itemImage, '100x100');

                let images = template.querySelectorAll('.js-color-Swatches__swatch img');
                
                for (var i = 0; i < images.length; i++) {
                    images[i].setAttribute('src', imageUrl);
                } 


                /***
                 * Preloads image, so it is displayed faster
                 */
                (new Image()).src = imageUrl;
            }

        }


        if (this.options.id && this.options.id !== null)
        {
            this.productCollectionCard_swatImages({ item: item, template: template, productCollectionCardObj: productCollectionCardObj })
        }

    }


    productCollectionCard_swatImages({ item, template, productCollectionCardObj }) {
        if (productCollectionCardObj && window.location.href.indexOf('/collections/') != -1 && window.location.href.indexOf('/products/') == -1) {
            template.addEventListener('dblclick', function(){
                window.location = template.querySelector('a.js-color-swatch__url').href;
            })
        }
        
        if (productCollectionCardObj && this.options.color !== item.color)
        {

            // if (!productCollectionCardObj.dom.swatchImage)  return this.dom.swatches.remove();

            const swatchImageOptions = JSON.parse(productCollectionCardObj.dom.swatchImage.dataset.productCollectionSwatchImageOptions);

            // if (!productCollectionCardObj.dom.swatchImage && !swatchImageOptions.width)  return this.dom.swatches.remove();

            if (!productCollectionCardObj.dom.swatchImage.hasChildNodes())
            {
                const imageElem = document.createElement('img');
                imageElem.draggable = false;
                const anchorElem = document.createElement('a');
                anchorElem.appendChild(imageElem);

                productCollectionCardObj.dom.swatchImage.appendChild(anchorElem);
            }

            const imageUrl = Shopify.Image.getSizedImageUrl(item.image, swatchImageOptions.width);

            template.addEventListener('mouseenter', () => {
                
                productCollectionCardObj.dom.swatchImage.style.display = 'block'
                productCollectionCardObj.dom.swatchImage.querySelector('a')?.setAttribute('href', item.url);
                productCollectionCardObj.dom.swatchImage.querySelector('img')?.setAttribute('src', imageUrl);
            })

            if (this.options.keep !== true)
            {
                template.addEventListener('mouseleave', () => {
                    productCollectionCardObj.dom.swatchImage.style.display = 'none'
                })
            }
        }
        else if (productCollectionCardObj && this.options.color === item.color)
        {
            template.addEventListener('mouseenter', () => {
                productCollectionCardObj.dom.swatchImage.style.display = 'none'
            })
        }
    }


    SwatchesOnProductPage({ item, itemListElement, template, currentColorObj }) {

        this.changeColorTitle({ item, itemListElement, template, currentColorObj });
        console.log(item)
        if (item.colorName)
        {
            template.querySelector('.js-color-swatch__url').setAttribute('title', item.colorName);
            template.querySelector('.js-color-Swatches__swatch').setAttribute('alt', item.colorName);
        }

 
        let globalSwatchValue = null;

        if (globalColorSwatches[item.color] != undefined)
        {
            globalSwatchValue = globalColorSwatches[item.color];
        }

        if (globalSwatchValue && globalSwatchValue.charAt(0) === '#') 
        {
            /**Hex code */
            template.querySelector('.js-color-Swatches__swatch').style.backgroundColor = globalSwatchValue;
            template.querySelector('.js-color-Swatches__swatch img').remove();
            console.log(item.color, 0, globalSwatchValue)
        }
        else
        {
            const itemImage = globalSwatchValue ? globalSwatchValue : item.image;

            if (itemImage)
            {
                /***
                 * Include this in theme {{ 'option_selection.js' | shopify_asset_url | script_tag }}
                 */
                 console.log(item.color, 1, globalSwatchValue)
                const imageUrl = Shopify.Image.getSizedImageUrl(itemImage, '100x100');

                template.querySelector('.js-color-Swatches__swatch img').setAttribute('src', imageUrl);

                /***
                 * Preloads image, so it is displayed faster
                 */
                (new Image()).src = imageUrl;
            }

        }
    }

    changeColorTitle({ item, itemListElement, template, currentColorObj }) {
        var productTitleElementGetter = '.js-product-title-' + this.dom.swatches.dataset.productId;
        var productTitleElement = document.querySelector(productTitleElementGetter);
        var productPageTitle = document.querySelector('.product-page-info__title h1');
        console.log(productTitleElement, item.title);

        if (this.options.color === item.color)
        {
            template.classList.add('is-selected')
        }

        template.querySelector('.js-color-swatch__url').setAttribute('href', item.url);

        template.addEventListener('mouseenter', () => {
            if (productTitleElement) {
                productTitleElement.innerHTML = item.title;
            } else if (productPageTitle) {
                productPageTitle.innerHTML = item.title;
            }
            
            //currentColorObj.element.innerText = item.colorName;
            if (this.options.keep === true)
            {
                itemListElement.querySelectorAll('.js-color-Swatches__item').forEach(elem => {
                    elem.classList.remove('is-selected')
                });

                template.classList.add('is-selected')
            } else
            {
                //If keep = false, then set color title = original color
                template.addEventListener('mouseleave', () => {
                    productTitleElement.innerHTML = productTitleElement.dataset.originalTitle;
                    //currentColorObj.element.innerText = currentColorObj.text;
                })
            }
        })
    }
}

class ColorSwatchesData {

    constructor() {
        this.options = {}
        this.data = {}
        this.init();
    }

    async init() {

        try
        {
            await this.getUrlFetchLimit();
            await this.getRequestUrls();
            await this.getProducts();
            await this.saveToSesseion();

        }
        catch (e)
        {
            console.error(e);
        }

        initSwatches({globalLinkedProducts: this.data});
        reInitSwatchesAfterEvent({globalLinkedProducts: this.data});
    }


    async getUrlFetchLimit() {
        return fetch('/collections/all?view=swatch-data-limit')
            .then(response => {
                const limit = response.json()
                this.options.urlLimit = limit;
            }).catch(e => {
                console.error(e);
            });
    }

    async getRequestUrls() {
        return new Promise((resolve) => {
            const requestUrls = []
            /**Get all available urls */
            if (this.options.urlLimit > 0)
            {
                for (let i = 1; i < (parseInt(Object.values(this.options.urlLimit)) + 1); i++)
                {
                    const urlFetch = fetch(`/collections/all?view=swatch-data&page=${ i }`).then((response) => response.json());
                    requestUrls.push(urlFetch)
                }
            }
            else
            {
                const urlFetch = fetch(`/collections/all?view=swatch-data&page=${ 1 }`).then((response) => response.json());
                requestUrls.push(urlFetch)
            }
            this.options.requestUrls = requestUrls;
            resolve()
        })
    }

    async getProducts() {
        const _this = this;
        return Promise.all(this.options.requestUrls).then((data) => {
            // Log the data to the console
            // You would do something with both sets of data here
            const merged = [].concat.apply([], data);
            /**Group the products so they are easier to find */
            const groupedProducts = groupBy(merged, 'sku');

            _this.data = groupedProducts;
        }).catch((e) => {
            // if there's an error, log it
            console.error(e);
        });
    }

    async saveToSesseion() {
        const mySession = window.sessionStorage;
        mySession.setItem("productSkus", JSON.stringify(this.data));
    }
}


const initSwatches = ({globalLinkedProducts}) => {
    const swatches = document.querySelectorAll('[data-swatches-template]');
    swatches.forEach(swatch => {
        void new ColorSwatches({ globalColorSwatches: globalColorSwatches, globalLinkedProducts, elem: swatch });
    });
}

const reInitSwatchesAfterEvent = ({globalLinkedProducts}) => {


    document.addEventListener('slick.afterChange', () => {
        
        initSwatches({globalLinkedProducts});
        
    })
    document.addEventListener('filter.loadContent', () => {

        initSwatches({globalLinkedProducts});
    }) 
}  



/**
 * Checking if storedProductSkusInSession exist, and is not an empty object
 */
if (storedProductSkusInSession && JSON.stringify(storedProductSkusInSession) !== '{}')
{
    //if swatches data init swatches
    initSwatches({globalLinkedProducts: storedProductSkusInSession});
    reInitSwatchesAfterEvent({globalLinkedProducts: storedProductSkusInSession});
}
else
{
    //Get swatches data from custom endpoint
    void new ColorSwatchesData();
}





